import { FormEnrollment } from "models/enrollments/FormEnrollment";
import { Node as Stage, NodePosition } from "models/nodes/Node";
import { useState } from "react";
import { useParams } from "react-router-dom";

interface NodeProps {
  node: Stage
  readonly: boolean;
  onDelete: (id: string) => void;
  onUpdate: (updatedNode: Stage) => void;
  workflowId: string;
}

const NodeComponent: React.FC<NodeProps> = ({ node, readonly, onDelete, onUpdate, workflowId }) => {

  const [index, setIndex] = useState<number>(node.index);
  const { teamId } = useParams<{ teamId: string; workflowId: string }>();

  if (!teamId || !workflowId) return null;

  const handleIndexChange = (newIndex: number) => {
    setIndex(() => newIndex);
    node.index = newIndex;
    onUpdate(node);
  }

  const isFormEnrollment = (enrollment: any): enrollment is FormEnrollment => {
    return enrollment && "form" in enrollment && enrollment.form?.name;
  };

  return (
    <div className="p-4 border border-gray-200 rounded-lg bg-white shadow-sm space-y-3">
      {isFormEnrollment(node.enrollment) && (
        <h4 className="text-md font-semibold text-gray-700">
          Form: {node.enrollment.form.name}
        </h4>
      )}

      <h4 className="text-md font-semibold">Stage {index}</h4>

      {!readonly && (
        <div>
          <label className="text-sm text-gray-700">
            <strong>Stage: </strong>
            <input
              disabled={readonly}
              type="number"
              value={index}
              onChange={(e) => handleIndexChange(Number(e.target.value))}
              className="mt-1 ml-2 px-2 py-1 w-12 border border-gray-300 rounded text-center"
            />
          </label>
        </div>
      )}

      {!readonly && (
        <button
          onClick={() => onDelete(node.id)}
          className="inline-flex items-center justify-center rounded-lg border border-red-300 bg-white px-3 py-1.5 text-sm font-medium text-red-700 hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
        >
          Delete
        </button>
      )}
    </div>
  );
}


export default NodeComponent;